/**
 * เหตุผลของ ส่งคืน HO (W7) — ตัวเลือกด่วน + ช่องพิมพ์เพิ่ม · API บังคับ 1..500 ตัวอักษร
 */

/** ตัวเลือกด่วนที่ต้องพิมพ์รายละเอียดเอง */
export const RETURN_REASON_OTHER = "อื่นๆ";

/** ตัวเลือกด่วนตามลำดับที่เจ้าของงานกำหนด */
export const RETURN_REASON_PRESETS = [
  "ร้านไม่ใช่ของสาขานี้",
  "จับคู่ร้านผิด",
  "สายไม่ได้วิ่งร้านนี้",
  RETURN_REASON_OTHER,
];

/** เพดานความยาวของ reason ที่ API รับ */
export const RETURN_REASON_MAX_LENGTH = 500;

/**
 * ประกอบเหตุผลที่จะส่ง API · null = ยังส่งไม่ได้
 *
 * - เลือกตัวเลือกด่วน (ไม่ใช่ อื่นๆ) → ใช้ตัวเลือกนั้น และต่อท้ายรายละเอียดถ้าพิมพ์มา
 * - อื่นๆ หรือไม่ได้เลือกตัวเลือก → ต้องพิมพ์เอง
 * - ยาวเกินเพดาน → ส่งไม่ได้ (ช่องพิมพ์บอกจำนวนตัวอักษรให้เห็นอยู่แล้ว)
 */
export const buildReturnReason = (
  preset: string | null,
  detail: string,
): string | null => {
  const text = detail.trim();
  let reason: string;

  if (preset && preset !== RETURN_REASON_OTHER) {
    reason = text ? `${preset} — ${text}` : preset;
  } else {
    if (!text) return null;
    reason = text;
  }

  return reason.length > RETURN_REASON_MAX_LENGTH ? null : reason;
};
